import { transformActions } from 'utils/';
import { GET_WAREHOUSE_USAGE } from 'actions/types';

const initialState = {
  data: [],
  isLoading: false,
};

/**
  @description Stores warehouses array details in redux state
  @param {[]} state
  @param {{}} action
  @returns {[]}
 */
function usage(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_WAREHOUSE_USAGE];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');

  if (type === GET_WAREHOUSE_USAGE) {
    return {
      data: [],
      isLoading: true,
    };
  }

  if (success.includes(type)) {
    return {
      data: payload,
      isLoading: false,
    };
  }

  if (failure.includes(type)) {
    return {
      data: [],
      isLoading: false,
    };
  }

  return state;
}

export default usage;
